<a href='#' (click)="click($event)">{{value}}</a>